window.addEventListener('load', () => {
    function layout() {
        let grids = [...document.querySelectorAll(".grid--masonry")];

        if (grids.length && getComputedStyle(grids[0]).gridTemplateRows !== "masonry") {
            grids = grids.map((grid) => ({
                _el: grid,
                gap: parseFloat(getComputedStyle(grid).gridRowGap),
                items: [...grid.childNodes].filter(
                    (c) => c.nodeType === 1 && +getComputedStyle(c).gridColumnEnd !== -1
                ),
                ncol: 0,
                mod: 0
            }));
            grids.forEach((grid) => {
                /* get the post relayout number of columns */
                let ncol = getComputedStyle(grid._el).gridTemplateColumns.split(" ").length;

                grid.items.forEach((c) => {
                    let new_h = c.getBoundingClientRect().height;

                    if (new_h !== +c.dataset.h) {
                        c.dataset.h = new_h;
                        grid.mod++;
                    }
                });

                /* if the number of columns has changed */
                if (grid.ncol !== ncol || grid.mod) {
                    /* update number of columns */
                    grid.ncol = ncol;

                    /* revert to initial positioning, no margin */
                    grid.items.forEach((c) => c.style.removeProperty("margin-top"));

                    /* if we have more than one column */
                    if (grid.ncol > 1) {
                        grid.items.slice(ncol).forEach((c, i) => {
                            let prev_fin = grid.items[i].getBoundingClientRect()
                                .bottom /* bottom edge of item above */,
                                curr_ini = c.getBoundingClientRect().top; /* top edge of current item */

                            c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`;
                        });
                    }

                    grid.mod = 0;
                }
            });
        }
    }

    function getFirstHiddenChild(el){
        children = el.querySelectorAll( 'div' );
        for ( let child of children ) {
            let style = window.getComputedStyle( child );
            if ( 'none' === style.display ) return child;
        }
    }

    layout(); /* initial load */
    addEventListener("resize", layout, false);
    
    // handle load more button
    const masonryEl = document.querySelector('.socialposts.grid--masonry');
    const loadBtn = document.getElementById('social_load');

    loadBtn.addEventListener('click', () => {
        console.log("TEST");
        if ( ! masonryEl.classList.contains('loadedMore') && !masonryEl.classList.contains('loadedAll') ){
            let hiddenChild = getFirstHiddenChild(masonryEl);
            masonryEl.classList.add('loadedMore');
            if(hiddenChild){
                hiddenChild.querySelector("a").focus();
            }
            layout();
        } else if ( masonryEl.classList.contains('loadedMore') ) {
            let hiddenChild = getFirstHiddenChild(masonryEl);
            masonryEl.classList.remove('loadedMore');
            masonryEl.classList.add('loadedAll');
            if(hiddenChild){
                hiddenChild.querySelector("a").focus();
            }
            layout();
        }
    })
});

// masonry
